module.exports = __webpack_public_path__ + "img/42_52.fd088351.png";